var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32753 0.828949C1.04782 1.10865 0.95459 1.57483 0.95459 2.13424V22.7392C0.95459 23.2986 1.14106 23.7648 1.42077 24.0445L1.514 24.1377L13.0752 12.5766V12.3901L1.32753 0.828949Z",
    fill: "url(#paint0_linear_93_147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8046 16.4924L12.9819 12.6698V12.3901L16.8046 8.56746L16.8978 8.66069L21.4663 11.2713C22.7716 12.0172 22.7716 13.2292 21.4663 13.9751L16.8046 16.4924Z",
    fill: "url(#paint1_linear_93_147)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 16.3992L12.9818 12.4834L1.32739 24.1378C1.79357 24.6039 2.44622 24.6039 3.28533 24.231L16.8977 16.3992Z",
    fill: "url(#paint2_linear_93_147)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 8.56746L3.28533 0.828933C2.44622 0.362757 1.79357 0.455993 1.32739 0.922169L12.9818 12.4833L16.8977 8.56746Z",
    fill: "url(#paint3_linear_93_147)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.8044 16.306L3.28533 23.9513C2.53945 24.4175 1.8868 24.3242 1.42063 23.9513L1.32739 24.0445L1.42063 24.1378C1.8868 24.5107 2.53945 24.6039 3.28533 24.1378L16.8044 16.306Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M1.32753 23.9513C1.04782 23.6716 0.95459 23.2054 0.95459 22.646V22.7392C0.95459 23.2986 1.14106 23.7648 1.42077 24.0445V23.9513H1.32753ZM21.4663 13.6954L16.8046 16.306L16.8978 16.3992L21.4663 13.7886C22.119 13.4157 22.3987 12.9495 22.3987 12.4834C22.3987 12.9495 22.0257 13.3225 21.4663 13.6954Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M3.28547 0.922178L21.4663 11.2713C22.0257 11.6442 22.3987 12.0172 22.3987 12.4833C22.3987 12.0172 22.119 11.551 21.4663 11.1781L3.28547 0.828943C1.98018 0.083061 0.95459 0.642472 0.95459 2.13423V2.22747C0.95459 0.828943 1.98018 0.176296 3.28547 0.922178Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_147",
    x1: 11.9563,
    y1: 1.95709,
    x2: -3.69132,
    y2: 17.6038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_147",
    x1: 23.1763,
    y1: 12.4843,
    x2: 0.616149,
    y2: 12.4843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_93_147",
    x1: 14.7784,
    y1: 14.624,
    x2: -6.44003,
    y2: 35.8425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_93_147",
    x1: -1.5657,
    y1: -5.99961,
    x2: 7.9098,
    y2: 3.47588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7386c53d0e6120905e754899bfb2ad8a.svg";
export { ForwardRef as ReactComponent };